// Shared non-identity columns for the Assignment Pipeline's tabs. The
// candidate-identity column (avatar/name/email combo) lives in
// CandidateCell.jsx now (candidateCellColumn) — these are the columns that
// come after it: status and "updated on" don't vary by tab, only the
// columns between them do.
//
// Explicit `width` matters here specifically: DataTable defaults to
// `table-fixed`, and no column anywhere in this feature set an explicit
// width — under `table-fixed` that makes every column split the table
// width equally regardless of how much content it actually holds, so a
// bare "31 Aug 2026" or single-word status ended up exactly as wide as the
// Candidate column (avatar + name + email) or the row-actions column
// (button + kebab + chevron). Giving these two shared, always-narrow
// columns a fixed width lets the identity column (still unconstrained —
// see CandidateCell.jsx) absorb the space they're no longer claiming.

import { statusLabel, formatDate } from './tabFormatters';

export const statusColumn = {
  key: 'status',
  header: 'Status',
  className: 'text-sm',
  width: '120px',
  align: 'left',
  render: (_v, row) => statusLabel(row.status),
};

export const mappedAtColumn = {
  key: 'mapped_at',
  header: 'Updated on',
  className: 'text-sm',
  width: '130px',
  render: (_v, row) => formatDate(row.mapped_at),
};
